
import './App.css';
import Navbarmenu from './components/inc/Navbarmenu';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter ,Route, Routes } from 'react-router-dom';
import Home from './components/pages/Home';
import About from './components/pages/About';
import Footer from './components/inc/Footer';
import OurFruits from './components/pages/Ourfruits';
import Seasonal from './components/pages/Seasonal';
import Testimonials from './components/pages/Testimonials';
import Contact from './components/pages/Contact';
import Sitemap from './components/inc/Sitemap';
import Faq from './components/inc/Faq';
function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Navbarmenu/>
      <Routes>
      <Route path='/' element={<Home/>}></Route>
      <Route path='/about' element={<About/>}></Route>
      <Route path='/ourfruit' element={<OurFruits/>}></Route>
      <Route path='/seasonal' element={<Seasonal/>}></Route>
      <Route path='/testimonial' element={<Testimonials/>}></Route>
      <Route path='/contact' element={<Contact/>}></Route>
      <Route path='/sitemap' element={<Sitemap/>}></Route>
      <Route path='/faq' element={<Faq/>}></Route>
      </Routes>
      <Footer/>
      </BrowserRouter>
    </div>
  );
}

export default App;
